export const trimString = (_, originalValue) => String(originalValue).trim()
